import { Component, Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

import { Observable, observable, Subject, Subscription } from 'rxjs';

import { LoginService } from '../../../../pages/login/login.service';
import { AppService, UserService } from '../../../../shared/service/user.service';

import { ConfirmService } from '../../../../shared/components/confirm/confirm.service';
import { timeout } from 'rxjs/operators';
import { AppSubject } from '../../../../shared/app-subject';
import { InvoiceService } from '../../../customer/invoice/invoice.service';

// Phải khớp chuỗi lỗi BE vininvoice IamCustomerServices.xml (~dòng 884). Đổi câu BE thì sửa ở đây. Ticket #2665
const AGREEMENT_NOT_SIGNED_KEYWORD = 'ký hợp đồng điện tử';

interface RunValue {
  idValue?: string;
  actionType: string;
  issueStatusId?: string;
  taxCode?: string;
  requireLoginKey?: boolean;
  idValues?: any;
}

interface SigningAttempt {
  attemptId: string;
  userId: string;
  signingType: string;
  idValue: string;
  createdAt: number;
}

@Injectable({
  providedIn: `root`
})
export class SigningService {

  readonly errorSubject: Subject<any>;
  readonly displaySubject: Subject<any>;
  addCTSSubscription?: Subscription;
  private batchResumePrompted = false;

  constructor(
    private http: HttpClient,
    private backend: HttpBackend,
    private confirmService: ConfirmService,
    private loginService: LoginService,
    private invoiceService: InvoiceService,
    private router: Router
  ) {
    this.http = new HttpClient(this.backend);
    this.errorSubject = new Subject<any>();
    this.displaySubject = new Subject<any>();
  }

  private showSigningFailedDialog(message: string): void {
    const agreementNotSigned = (message || '').normalize('NFC')
      .includes(AGREEMENT_NOT_SIGNED_KEYWORD.normalize('NFC'));
    if (agreementNotSigned) {
      this.confirmService.setConfirmDialog({
        message,
        header: 'Ký điện tử không thành công',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Đến trang hợp đồng',
        rejectLabel: 'Đóng',
        acceptVisible: true,
        accept: () => this.router.navigate(['/customer/system/orders'])
      });
      return;
    }
    this.confirmService.setConfirmDialog({
      message,
      header: 'Ký điện tử không thành công',
      icon: 'pi pi-exclamation-triangle',
      rejectLabel: 'Đóng',
      acceptVisible: false
    });
  }

  run(runValue: RunValue): Promise<void> {
    return new Promise((resolve, reject) => {
      AppSubject.setReloadData('')
      if (this.isPendingBatchSigning(runValue)) {
        this.prepareBatchSigningRunValue(runValue).then((preparedRunValue) => {
          this.run(preparedRunValue).then(resolve).catch(reject);
        }).catch(reject);
        return;
      }
      try {
        this.prepareSigningAttempt(runValue);
      } catch (error) {
        this.showSigningError(error);
        reject(error);
        return;
      }
      const signingTypes = UserService.get(UserService.KEY.SIGNING_TYPES);
      let hasSigningTypes = false;
      if (signingTypes && signingTypes !== 'NULL') {
        try {
          hasSigningTypes = JSON.parse(signingTypes).length > 0;
        } catch (e) {
          hasSigningTypes = false;
        }
      }
      if (hasSigningTypes && UserService.get('SIGNING') !== 'newCert') {
        this.displaySubject.next('form1');
      }

      if (UserService.get('SIGNING') || !hasSigningTypes) {
        if (UserService.get('SIGNING') === 'UsbTokenSigning' || UserService.get('SIGNING') === 'newCert' || !hasSigningTypes) {
          this.http.get('http://localhost:11789/test').pipe(timeout(1000)).subscribe({
            next: (res: any) => {
              if (res?.receiveDataFromBrowser === "Y") {
                const data = {
                  signingType: runValue.actionType,
                  idValue: runValue.idValue,
                  idValues: runValue.idValues,
                  taxCode: runValue.taxCode || UserService.getUser().partyTaxId,
                  signingAttemptId: this.prepareSigningAttempt(runValue)?.attemptId,
                  responseContentType: "application/json"
                };
                const url = window.location.origin + '/api/rest/s1';
                this.http.put(`${url}/iam-common/signing`, data, { headers: { "x-csrf-token": AppService.get('MOQUI_SESSION_TOKEN') } }).subscribe({
                  next: (result: any) => {
                    this.displaySubject.next('form3');
                    this.http.post('http://localhost:11789/signing', result).subscribe({
                      next: (response: any) => {
                        if (response?.success) {
                          this.http.post(`${url}/iam-common/complete-signing`, response, { headers: { "x-csrf-token": AppService.get('MOQUI_SESSION_TOKEN') } },).subscribe({
                            next: (finalResult: any) => {
                              if (finalResult?.idValue) {
                                this.clearSigningAttempt(runValue);
                                AppSubject.setReloadData('success')
                                this.displaySubject.next('closeForm3');
                                resolve();
                              } else if (finalResult?.errorMessage) {
                                this.confirmService.setConfirmDialog({
                                  message: `[${finalResult?.errorCode}] ${finalResult?.errorMessage}`,
                                  header: 'Ký điện tử không thành công',
                                  icon: 'pi pi-exclamation-triangle',
                                  rejectLabel: 'Đóng',
                                  acceptVisible: false
                                });
                                AppSubject.setReloadData('error')
                                this.displaySubject.next('closeForm3');
                                reject();
                              } else {
                                reject();
                              }
                            }, error: error => {
                              this.showSigningFailedDialog(`[${error?.error.errorCode}] ${error?.error.errors}`);
                              AppSubject.setReloadData('error')
                              this.displaySubject.next('closeForm3');
                              reject();
                            }
                          })
                        } else if (response?.errorMessage) {
                          this.confirmService.setConfirmDialog({
                            message: `[${response?.errorCode}] ${response?.errorMessage}`,
                            header: 'Ký điện tử không thành công',
                            icon: 'pi pi-exclamation-triangle',
                            rejectLabel: 'Đóng',
                            acceptVisible: false
                          });
                          const input = {
                            success: "N",
                            idValue: runValue.idValue,
                            signingType: runValue.actionType,
                            signingAttemptId: this.getSigningAttempt(runValue)?.attemptId
                          }
                          this.http.post(`${url}/iam-common/complete-signing`, input, { headers: { "x-csrf-token": AppService.get('MOQUI_SESSION_TOKEN') } },).subscribe({
                            next: (finalResult: any) => {
                              if (finalResult?.idValue) {
                                this.clearSigningAttempt(runValue);
                                AppSubject.setReloadData('error')
                                this.displaySubject.next('closeForm3');
                                resolve();
                              } else {
                                reject();
                              }
                            }, error: error => {
                              reject();
                            }
                          })
                        } else {
                          reject();
                        }
                      }, error: error => {
                        reject();
                      }
                    })
                  }, error: error => {
                    this.handleSigningAttemptError(error, runValue);
                    this.showSigningFailedDialog(this.getSigningErrorMessage(error));
                    reject();
                  }
                })
              } else {
                let loginKey = '';
                if (runValue.requireLoginKey !== false) {
                  const apiKey: any = new Promise(resolve => {
                    this.loginService.getApiKey().subscribe(res => {

                      resolve(res);
                    });
                  });
                  loginKey = apiKey.token;
                }

                const data = {
                  baseUrl: window.location.origin + '/api',
                  loginKey,
                  csrfToken: AppService.get('MOQUI_SESSION_TOKEN'),
                  actionType: runValue.actionType,
                  idValue: runValue.idValue,
                  taxCode: runValue.taxCode || UserService.getUser().partyTaxId,
                  signingAttemptId: this.prepareSigningAttempt(runValue)?.attemptId
                };
                this.http.post('http://localhost:11789/signing', data).subscribe({
                  next: (response: any) => {

                    if (response?.success) {
                      this.clearSigningAttempt(runValue);
                      AppSubject.setReloadData('success')
                      resolve();
                    } else if (response?.errorMessage) {
                      this.confirmService.setConfirmDialog({
                        message: `[${response?.errorCode}] ${response?.errorMessage}`,
                        header: 'Ký điện tử không thành công',
                        icon: 'pi pi-exclamation-triangle',
                        rejectLabel: 'Đóng',
                        acceptVisible: false
                      });
                      AppSubject.setReloadData('error')
                      reject();
                    } else {
                      reject();
                    }
                  }, error: error => {
                    this.handleSigningAttemptError(error, runValue);
                    this.errorSubject.next(error);
                    reject();
                  }
                })
              }
              UserService.set(UserService.KEY.SIGNING, '')
            },
            error: async error => {
              if (error.status === 200) {
                {
                  let loginKey = '';
                  if (runValue.requireLoginKey !== false) {
                    const apiKey: any = await new Promise(resolve => {
                      this.loginService.getApiKey().subscribe(res => {

                        resolve(res);
                      });
                    });
                    loginKey = apiKey.token;
                  }

                  const data = {
                    baseUrl: window.location.origin + '/api',
                    loginKey,
                    csrfToken: AppService.get('MOQUI_SESSION_TOKEN'),
                    actionType: runValue.actionType,
                    idValue: runValue.idValue,
                    taxCode: runValue.taxCode || UserService.getUser().partyTaxId,
                    signingAttemptId: this.prepareSigningAttempt(runValue)?.attemptId
                  };
                  this.http.post('http://localhost:11789/signing', data).subscribe({
                    next: (response: any) => {

                      if (response?.success) {
                        this.clearSigningAttempt(runValue);
                        AppSubject.setReloadData('success')
                        resolve();
                      } else if (response?.errorMessage) {
                        this.confirmService.setConfirmDialog({
                          message: `[${response?.errorCode}] ${response?.errorMessage}`,
                          header: 'Ký điện tử không thành công',
                          icon: 'pi pi-exclamation-triangle',
                          rejectLabel: 'Đóng',
                          acceptVisible: false
                        });
                        AppSubject.setReloadData('error')
                        reject();
                      } else {
                        reject();
                      }
                    }, error: error => {
                      this.handleSigningAttemptError(error, runValue);
                      this.errorSubject.next(error);
                      reject();
                    }
                  })
                }
              } else {
                this.errorSubject.next(error);
                reject();
              }
            }

          })
        } else {
          const url = window.location.origin + '/api/rest/s1';
          this.http.get(`${url}/iam-common/remote-signing?partyClassificationId=${UserService.get('SIGNING')}`, { headers: { "x-csrf-token": AppService.get('MOQUI_SESSION_TOKEN') } }).subscribe({
            next: (result: any) => {
              if (result.listData) {
                UserService.set(UserService.KEY.REMOTE_SIGNING, JSON.stringify(result.listData))
                this.displaySubject.next('form2');
              }
            }
            , error: async error => {
            }
          })
        }
      } else {
        UserService.set(UserService.KEY.RUN_VALUE, JSON.stringify(runValue))
      }
    });
  }

  remoteSigning(data: any): Observable<any> {
    const runValue = data?.idValue && data?.signingType ? {
      idValue: data?.idValue,
      actionType: data?.signingType,
      issueStatusId: data?.issueStatusId
    } : this.getCurrentRunValue();
    const payload = Object.assign({}, data, { signingAttemptId: this.prepareSigningAttempt(runValue)?.attemptId });
    const obs = this.http.post(`/api/rest/s1/iam-common/remote-signing`, payload, { headers: { "x-csrf-token": AppService.get('MOQUI_SESSION_TOKEN') } });
    return new Observable(subscriber => {
      obs.subscribe({
        next: (val) => {
          this.clearSigningAttempt(runValue);
          subscriber.next(val);
        },
        error: (err) => {
          this.handleSigningAttemptError(err, runValue);
          subscriber.error(err);
        },
        complete: () => subscriber.complete()
      });
    });
  }

  promptResumeBatchSigningAttempt(): void {
    if (this.batchResumePrompted) {
      return;
    }

    const attempt = this.findLatestBatchSigningAttempt();
    if (!attempt) {
      return;
    }

    this.batchResumePrompted = true;
    this.confirmService.setConfirmDialog({
      message: 'Đang thực hiện ký hóa đơn hàng loạt, bạn có muốn hoàn thành quy trình ký này không?',
      header: 'Ký hóa đơn hàng loạt',
      icon: 'pi pi-question-circle',
      accept: () => this.resumeBatchSigningAttempt(attempt),
      reject: () => this.rejectBatchSigningAttempt(attempt)
    });
  }

  private isPendingBatchSigning(runValue?: RunValue): boolean {
    return !!runValue?.idValues?.length
      && !runValue?.idValue
      && runValue.actionType === 'invoiceBatchSigning';
  }

  private prepareBatchSigningRunValue(runValue: RunValue): Promise<RunValue> {
    return new Promise((resolve, reject) => {
      this.invoiceService.putToWorkEffort(runValue.idValues).subscribe({
        next: ({workEffortId}) => {
          if (workEffortId) {
            const preparedRunValue = {
              ...runValue,
              idValue: workEffortId,
              issueStatusId: runValue.issueStatusId || 'InvNotIssued'
            };
            UserService.set(UserService.KEY.RUN_VALUE, JSON.stringify(preparedRunValue));
            resolve(preparedRunValue);
          } else {
            reject(new Error('Không tạo được phiên ký hàng loạt'));
          }
        },
        error: (error) => reject(error)
      });
    });
  }

  private prepareSigningAttempt(runValue?: RunValue): SigningAttempt | undefined {
    if (!this.shouldUseSigningAttempt(runValue)) {
      return undefined;
    }

    const key = this.getSigningAttemptKey(runValue);
    if (!key) {
      return undefined;
    }

    const stored = sessionStorage.getItem(key);
    if (stored) {
      return JSON.parse(stored);
    }

    const issueStatusId = runValue?.issueStatusId || (runValue?.actionType === 'toKhai100' ? 'EiurNotSent' : '');
    if (!this.canStartNewAttempt(runValue?.actionType || '', issueStatusId)) {
      throw new Error(
        issueStatusId === 'InvIssuing'
          ? 'Hóa đơn đang được phát hành tại một phiên làm việc khác.'
          : 'Trạng thái hóa đơn không cho phép thực hiện ký.'
      );
    }

    const attempt: SigningAttempt = {
      attemptId: this.createUuid(),
      userId: this.getSigningUserId(),
      signingType: runValue?.actionType || '',
      idValue: runValue?.idValue || '',
      createdAt: Date.now()
    };

    sessionStorage.setItem(key, JSON.stringify(attempt));
    return attempt;
  }

  private getSigningAttempt(runValue?: RunValue): SigningAttempt | undefined {
    const key = this.getSigningAttemptKey(runValue);
    if (!key) {
      return undefined;
    }
    const stored = sessionStorage.getItem(key);
    return stored ? JSON.parse(stored) : undefined;
  }

  private findLatestBatchSigningAttempt(): SigningAttempt | undefined {
    const prefix = `signing-attempt:${this.getSigningUserId()}:`;
    const attempts: SigningAttempt[] = [];

    for (let index = 0; index < sessionStorage.length; index++) {
      const key = sessionStorage.key(index) || '';
      if (!key.startsWith(prefix)) {
        continue;
      }

      const parts = key.split(':');
      const signingType = parts[2];
      if (!['invoiceBatchSigning', 'posBatchSigning'].includes(signingType)) {
        continue;
      }

      const stored = sessionStorage.getItem(key);
      if (!stored) {
        continue;
      }

      try {
        const attempt = JSON.parse(stored) as SigningAttempt;
        if (attempt?.attemptId && attempt?.idValue && attempt?.signingType) {
          attempts.push(attempt);
        }
      } catch {
      }
    }

    return attempts.sort((left, right) => (right.createdAt || 0) - (left.createdAt || 0))[0];
  }

  private resumeBatchSigningAttempt(attempt: SigningAttempt): void {
    const runValue = this.getBatchSigningRunValue(attempt);

    UserService.set(UserService.KEY.RUN_VALUE, JSON.stringify(runValue));
    UserService.set(UserService.KEY.SIGNING, 'UsbTokenSigning');
    this.run(runValue).catch(() => {
      UserService.set(UserService.KEY.SIGNING, '');
    });
  }

  private completeSigning(runValue: RunValue, success: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const url = window.location.origin + '/api/rest/s1';
      const input = {
        success,
        idValue: runValue.idValue,
        signingType: runValue.actionType,
        signingAttemptId: this.getSigningAttempt(runValue)?.attemptId
      };

      this.http.post(`${url}/iam-common/complete-signing`, input, { headers: { "x-csrf-token": AppService.get('MOQUI_SESSION_TOKEN') } }).subscribe({
        next: (finalResult: any) => {
          if (finalResult?.idValue) {
            this.clearSigningAttempt(runValue);
            AppSubject.setReloadData(success === 'Y' ? 'success' : 'error');
            this.displaySubject.next('closeForm3');
            resolve();
          } else {
            reject();
          }
        },
        error: error => {
          reject(error);
        }
      });
    });
  }

  private rejectBatchSigningAttempt(attempt: SigningAttempt): void {
    const runValue = this.getBatchSigningRunValue(attempt);

    UserService.set(UserService.KEY.RUN_VALUE, JSON.stringify(runValue));
    this.completeSigning(runValue, 'N').finally(() => {
      this.batchResumePrompted = false;
    });
  }

  private getBatchSigningRunValue(attempt: SigningAttempt): RunValue {
    return {
      idValue: attempt.idValue,
      actionType: attempt.signingType,
      issueStatusId: 'InvNotIssued'
    };
  }

  private clearSigningAttempt(runValue?: RunValue): void {
    const key = this.getSigningAttemptKey(runValue || this.getCurrentRunValue());
    if (key) {
      sessionStorage.removeItem(key);
    }
  }

  private getSigningAttemptKey(runValue?: RunValue): string {
    if (!this.shouldUseSigningAttempt(runValue) || !runValue?.idValue) {
      return '';
    }
    return `signing-attempt:${this.getSigningUserId()}:${runValue.actionType}:${runValue.idValue}`;
  }

  private shouldUseSigningAttempt(runValue?: RunValue): boolean {
    if (!runValue?.actionType || !runValue?.idValue) {
      return false;
    }
    return runValue.actionType === 'toKhai100'
      || runValue.actionType === 'invoiceBatchSigning'
      || runValue.actionType === 'posBatchSigning'
      || runValue.actionType.indexOf('Invoice') === 0;
  }

  private canStartNewAttempt(signingType: string, issueStatusId: string): boolean {
    if (signingType === 'toKhai100') {
      return !issueStatusId || ['EiurNotSent', 'EiurSellerSigningError', 'EiurDataNotValid'].includes(issueStatusId);
    }
    if (!issueStatusId) {
      return true;
    }
    return ['InvNotIssued', 'InvIssuedError'].includes(issueStatusId);
  }

  private getCurrentRunValue(): RunValue | undefined {
    try {
      const raw = UserService.get(UserService.KEY.RUN_VALUE);
      return raw ? JSON.parse(raw) : undefined;
    } catch {
      return undefined;
    }
  }

  private getSigningUserId(): string {
    const user = UserService.getUser() || {};
    return user.userId || user.userLoginId || user.partyId || user.partyTaxId || 'anonymous';
  }

  private createUuid(): string {
    const cryptoRef = window.crypto as any;
    if (cryptoRef?.randomUUID) {
      return cryptoRef.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
      const random = Math.random() * 16 | 0;
      const value = char === 'x' ? random : (random & 0x3 | 0x8);
      return value.toString(16);
    });
  }

  private handleSigningAttemptError(error: any, runValue?: RunValue): void {
    const body = error?.error || error;
    const code = body?.code || body?.errorCode || body?.error || '';
    if (code === 'SIGNING_ATTEMPT_NOT_OWNER') {
      this.clearSigningAttempt(runValue);
    }
  }

  private getSigningErrorMessage(error: any): string {
    const body = error?.error || error;
    const code = body?.code || body?.errorCode || body?.error || '';
    if (code === 'SIGNING_ATTEMPT_NOT_OWNER') {
      return 'Hóa đơn đang được phát hành tại một phiên làm việc khác.';
    }
    return `[${body?.errorCode || ''}] ${body?.errors || body?.errorMessage || body?.message || 'Không thể ký điện tử'}`;
  }

  private showSigningError(error: any): void {
    const body = error?.error || error;
    this.confirmService.setConfirmDialog({
      message: body?.errorMessage || body?.message || `${body}`,
      header: 'Ký điện tử không thành công',
      icon: 'pi pi-exclamation-triangle',
      rejectLabel: 'Đóng',
      acceptVisible: false
    });
  }
}
